import { Configuration } from "../Utils/Configuration";

export async function get(url: string, token: string, headers: Record<string, string> = {}): Promise<Response> {
  return request(url, token, `GET`, null, headers);
}

export async function post(
  url: string,
  token: string,
  body: BodyInit | null = null,
  headers: Record<string, string> = {}
): Promise<Response> {
  return request(url, token, `POST`, body, { "Content-Type": `application/json`, ...headers });
}

export async function patch(
  url: string,
  token: string,
  body: BodyInit | null = null,
  headers: Record<string, string> = {}
): Promise<Response> {
  return request(url, token, `PATCH`, body, { "Content-Type": `application/json`, ...headers });
}

export async function del(url: string, token: string, headers: Record<string, string> = {}): Promise<Response> {
  return request(url, token, `DELETE`, null, headers);
}

async function request(
  endpoint: string,
  token: string,
  method = `GET`,
  body: BodyInit | null = null,
  headers: Record<string, string> = {}
): Promise<Response> {
  const response = await fetch(`${(await Configuration.getInstanceAsync()).getBackendBaseUrl()}/api/v1/${endpoint}`, {
    method,
    body,
    headers: {
      Accept: `application/json`,
      Authorization: `Bearer ${token}`,
      ...(headers ?? {})
    }
  });

  await assertSuccessStatus(response);
  return response;
}

export async function assertSuccessStatus(response: Response): Promise<void> {
  if (response.status < 200 || response.status >= 300) {
    const content = await response.clone().text();
    if (content.includes(`<html`)) {
      throw new Error(`${response.status} - ${response.statusText} - ${response.url}`);
    }
    throw new Error(JSON.parse(await response.clone().text()).errorMessage);
  }
}

export async function asType<T>(response: Response, showError = true): Promise<T> {
  try {
    return JSON.parse(await response.text());
  } catch (e) {
    if (showError) {
      console.error(`Error: Parsing response text into JSON type failed.`, e);
    }
    return null;
  }
}

export function asQueryParams(params: Record<string, unknown>): string {
  return Object.entries(params)
    .map(([param, value]) => `${param}=${encodeURIComponent(value.toString())}`)
    .join(`&`);
}
